exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox[data-v-d9a7e56e] {\n  display: block;\n  margin: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}", ""]);

